import MotivoCualitativoForm from "./MotivoCualitativoForm";
import { postData } from "../../Utils/Http/api";

const MotivoCualitativoAdd = () => (
  <MotivoCualitativoForm
    titulo="Agregar Motivo de Campaña Cualitativa"
    descripcion="Define un motivo de gestión cualitativa (ej. falta de presentación de una DDJJ) para ofrecer al importar casos."
    valoresIniciales={{ descripcion: "", activo: true }}
    onGuardar={(datos) => postData("/MotivoCualitativoAlta", datos)}
    mensajeExito="¡Motivo agregado exitosamente!"
  />
);

export default MotivoCualitativoAdd;
